import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import styles from "./styles.module.css";
import CardFrota from './cardFrota'
import { BsFillPlusCircleFill } from "react-icons/bs";
import api from '../../services/api_escala';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import Swal from 'sweetalert2';
import moment from 'moment';

export default function PorFrota() {

    const { data } = queryString.parse(useLocation().search);

    const [cenario, setCenario] = useState({});
    const [frentes, setFrentes] = useState([]);
    const [frotas, setFrotas] = useState([]);
    const [codFrota, setCodFrota] = useState('');
    const [modalAddFrotaOpen, setModalAddFrotaOpen] = useState(false);
    const [selectedFrente, setSelectedFrente] = useState({});

    useEffect(() => {
        api.get(`/frente`).then(function (response) {
            if (response.data) {
                setFrentes(response.data);
            }

        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, []);

    useEffect(() => {
        api.get(`/frota`).then(function (response) {
            if (response.data) {
                // setFrentes(response.data);
            }

        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])


    useEffect(() => {
        api.get(`/cenarioedicao/bydata?data=${data}`).then(function (response) {
            if (response.data) {

                console.log(response.data);
                // return;

                if (response.data.erro) {
                    Swal.fire(response.data.erro);
                    return;
                }

                if (response.data.cenarioatual) {
                    Swal.fire(`CARREGANDO OS DADOS DO CENÁRIO ${moment(data).utc().format('DD/MM/YYYY')}`);
                    return;
                }
                if (response.data.cenarioedit) {
                    Swal.fire(`CARREGANDO OS DADOS DO CENÁRIO ${moment(data).utc().format('DD/MM/YYYY')}`);
                    return;
                }

                if (!response.data.lastcenario) {
                    Swal.fire({
                        title: `NÃO HÁ ATUALMENTE NENHUM CENÁRIO CADASTRADO ANTES DE ${moment(data).utc().format('DD/MM/YYYY')}, DESEJA INICIAR UM CENÁRIO NOVO?`,
                        showDenyButton: true,
                        confirmButtonText: 'SIM',
                        denyButtonText: `CANCELAR`,
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                            Swal.fire(`INICIANDO A ALTERAÇÃO DE UM CENÁRIO NOVO NA DATA ${moment(data).utc().format('DD/MM/YYYY')}`)
                        } else if (result.isDenied) {
                            window.history.back();
                        }
                    });
                    return;
                }

                if (response.data.lastcenario) {
                    Swal.fire({
                        title: `NÃO HÁ ATUALMENTE NENHUM CENÁRIO PARA A DATA ${moment(data).utc().format('DD/MM/YYYY')},
                    DESEJA CARREGAR OS DADOS DA DATA ${moment(response.data.lastcenario.data).utc().format('DD/MM/YYYY')} PARA EDIÇÃO?`,
                        showDenyButton: true,
                        confirmButtonText: 'SIM',
                        denyButtonText: `CANCELAR`,
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                            Swal.fire(`CARREGANDO OS DADOS DO CENÁRIO ${moment(response.data.lastcenario.data).utc().format('DD/MM/YYYY')}`)
                        } else if (result.isDenied) {
                            window.history.back();
                        }
                    });
                    return;
                }
            }

        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [data]);

    function handleSelectFrente(id) {
        const objfrente = Object.assign({}, frentes.find(frente => frente.id === id));
        setSelectedFrente(objfrente);
        api.get(`/posicao/frente/${id}`).then(function (response) {
            if (response.data) {
                console.log('retorno', response.data);
                setFrotas(response.data);
                // setFrentes(response.data);
            }

        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderFrentes() {
        return (
            frentes.map((frente, index) => {
                if (selectedFrente && selectedFrente.id === frente.id) {
                    return (
                        <li key={index} onClick={() => handleSelectFrente(frente.id)} className={styles.selected}>{frente.descricao}</li>
                    )
                } else {
                    return (
                        <li key={index} onClick={() => handleSelectFrente(frente.id)}>{frente.descricao}</li>
                    )
                }

            })
        )
    }

    function fecharModalAddFrota() {
        setModalAddFrotaOpen(false);
    }

    function handleAlocar() {
        const obj ={
            codfrota: codFrota,
            idfrente: selectedFrente.id
        }
        api.post(`/posicao`, obj).then(function (response) {
            if (response.data) {
                console.log(response.data);
                handleSelectFrente(selectedFrente.id);
                setModalAddFrotaOpen(false);
                setCodFrota('');
            }

        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderModalAddFrota() {
        return (
            <div
                className={(modalAddFrotaOpen ? "modal-despesas" : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fecharModalAddFrota()}
                ><b>x</b></span>
                <div>
                    <h3><b>CADASTRAR NOVA FROTA</b></h3>
                    <input type="text" value={codFrota} onChange={(e) => setCodFrota(e.target.value)} />
                    <input type="button" value="alocar" onClick={() => handleAlocar()} />

                </div>

            </div>
        )
    }

    function renderFrotas() {
        return (
            frotas.map((frota) => {
                return (
                    <div className={styles.contentbody}>
                        <CardFrota frota={frota} />
                        {/* <div className={styles.newfrota}>
                                <BsFillPlusCircleFill size="100" color="green" onClick={() => setModalAddFrotaOpen(true)} />
                            </div> */}
                    </div>
                )
            })


        )
    }

    return (
        <>
            {renderModalAddFrota()}
            <div className="container-lg">
                <Header title="VISUALIZAÇÃO POR FROTA" />

                <div className={styles.form}>
                    <div className={styles.items}>
                        <label>FROTA:</label>
                        <input type="text" className={styles.fromcontrol}></input>
                    </div>
                    <div className={styles.items}>
                        <label>MATRICULA:</label>
                        <input type="text" className={styles.fromcontrol}></input>
                    </div>
                    <div className={styles.items}>
                        <label>NOME:</label>
                        <input type="text" className={styles.fromcontrol}></input>
                    </div>
                    <div className={styles.notificacao}>
                        <div className={styles.notification}>
                            <div className={styles.contentnotification}>
                                <div className={styles.descricao}>
                                    PESSOAS
                                </div>

                                <div className={styles.countpessoas}>
                                    1123
                                </div>
                            </div>

                            <div className={styles.contentnotification}>
                                <div className={styles.descricao}>
                                    FROTAS
                                </div>
                                <div className={styles.countpessoas}>
                                    111
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.content}>
                    <div className={styles.teste}>
                        <h5><b>FRENTES</b></h5>
                        <ul className={styles.none}>
                            {renderFrentes()}
                        </ul>
                    </div>
                    <div className={styles.data}>
                        {renderFrotas()}
                        <div className={styles.newfrota}>
                            <BsFillPlusCircleFill size="100" color="green" onClick={() => setModalAddFrotaOpen(true)} />
                        </div>
                    </div>
                </div>
                <input type="buttom" value="GRAVAR CENARIO" className='btn-sm btn-success' />
            </div>

        </>
    )
}